import repository from '@/services/repository';

const resource = '/Counters';

export default {
    get() {
        return repository.get<any[]>(`${resource}`);
    },
    reset(name: string) {
        return repository.post(`${resource}/${name}/reset`);
    },
    set(name: string, value: number) {
        return repository.post(`${resource}/${name}/set/${value}`);
    },
};
